const getStorageJSON = (item, returnNull = false) => {
  try {
    const fallback = returnNull ? null : {};
    return JSON.parse(localStorage.getItem(item)) ?? fallback;
  } catch {
    return {};
  }
};

const setStorageJSON = (item, value) => {
  try {
    localStorage.setItem(item, JSON.stringify(value));
  } catch {
    /* empty */
  }
  return value;
};

export { getStorageJSON, setStorageJSON };
